import { useReportingStore } from '../stores/ReportingStore';
import { mainAxios as axios } from './axios';

export const createReport = async (data) => {
  return axios.post(`/reporting/report`, data)
}
export const getReports = async () => {
  let newReports = await axios.get(`/reporting/reports`)

  if (newReports) {
    useReportingStore.getState().setReports(newReports.data.reports)

  }
  return newReports
}
export const findReport = async (report_id) => {
  return axios.get(`/reporting/report/${report_id}`)
}
export const editReport = async (report_id, data) => {
  return axios.put(`/reporting/report/${report_id}`, data)
}
export const deleteReport = async (report_id) => {
  return axios.delete(`/reporting/report/${report_id}`)
}

function handleSingleStats(data) {
  return { ...data, linkedin_sent: data.linkedin_invitation_sent + data.linkedin_message_sent + data.linkedin_visit_profile, }
}

export const getGlobalReport = async () => {
  let res = await axios.get(`/statistics/global`)

  if (res.data) {
    useReportingStore.getState().setGlobalStats(handleSingleStats(res.data.statistics));
    useReportingStore.getState().setActualStats(handleSingleStats(res.data.statistics));
  }

  return res
}

export const getGlobalReportDetailed = async ({ date_range, limit_to_programmation_ids, limit_to_integration_ids }) => {
  let res = await axios.post(`/statistics/global/detailed`, { date_range, limit_to_programmation_ids, limit_to_integration_ids })

  if (res.data) {
    useReportingStore.getState().setActualStats(handleSingleStats(res.data.statistics));
  }

  return res
}

export function handleDateStats(data, withinStats) {
  if (withinStats) {
    return data.map((item) => ({
      ...item.stats,
      date: new Date(item.date).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit" }),
      linkedin_sent: item.stats.linkedin_invitation_sent + item.stats.linkedin_message_sent + item.stats.linkedin_visit_profile,
    }))

  }
  return data.map((item) => ({
    ...item,
    date: new Date(item.date).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit" }),
    linkedin_sent: item.linkedin_invitation_sent + item.linkedin_message_sent + item.linkedin_visit_profile,
  }))
}

export const getGlobalReportByDate = async ({ date_range }) => {
  let res = await axios.post(`/statistics/date`, { ...date_range })

  if (res.data) {
    useReportingStore.getState().setActualStatsDate(handleDateStats(res.data.statistics, false));
  }

  return res
}

export const getGlobalReportByDateDetailed = async ({ date_range, limit_to_programmation_ids, limit_to_integration_ids, shouldUpdate = true }) => {
  let res = await axios.post(`/statistics/date/detailed`, { date_range, limit_to_programmation_ids, limit_to_integration_ids })

  if (res.data && shouldUpdate) {
    useReportingStore.getState().setActualStatsDate(handleDateStats(res.data.statistics, true));
  }

  return res
}
